const commonDocs = [
  {
    typ: "specifikace",
    nazev: "Technický list (PDF)",
    soubor: "https://www.lightwell.cz/dokumenty/LightWell-LEDBAR-technicky-list.pdf"
  },
  {
    typ: "certifikace",
    nazev: "Prohlášení o shodě (PDF)",
    soubor: "https://www.lightwell.cz/dokumenty/LightWell-Prohlaseni-o-shode.pdf"
  }
];

const commonImages = [
  "https://www.lightwell.cz/media/produkty/ledbar-hero.webp",
  "https://www.lightwell.cz/media/produkty/ledbar-bar.webp",
  "https://www.lightwell.cz/media/produkty/ledbar-detail-cocka.webp"
];

const sourceSpecs = [
  { parametr: "Napětí", hodnota: "12/24V DC" },
  { parametr: "Ochrany", hodnota: "Přetížení, přepětí, zkrat" },
  { parametr: "Provozní teplota", hodnota: "-20 až +45 °C" },
  { parametr: "Záruka", hodnota: "3 roky" },
  { parametr: "Životnost", hodnota: "> 35 000h" }
];

const createSource = ({
  slug,
  nazev,
  perex,
  seo,
  obrazky,
  obrazekKarty,
  specifikace
}) => ({
  slug,
  kategorie: "zdroje",
  nazev,
  perex,
  seo,
  obrazky,
  obrazekKarty,
  specifikace: [...specifikace, ...sourceSpecs],
  dokumenty: []
});

export const products = [
  {
    slug: "24v-9-6w-4000k",
    kategorie: "ledbary",
    nazev: "LEDBAR 24V 9,6W 4000K",
    perex: "Neutrálně bílé lineární osvětlení pro interiérové světelné boxy, kuchyňské linky a podsvícení nábytku.",
    seo: {
      title: "LEDBAR 24V 9,6W 4000K – LED bar pro světelné boxy | LightWell",
      description: "LEDBAR 24V, 9,6W, 4000K, 1250lm. Lineární LED bar pro interiérové světelné boxy hloubky 4–10cm. Životnost 50 000h, záruka 5 let."
    },
    obrazky: commonImages,
    specifikace: [
      { parametr: "Příkon", hodnota: "9,6W" },
      { parametr: "Napětí", hodnota: "24V DC" },
      { parametr: "Teplota barev", hodnota: "4000K" },
      { parametr: "Světelný tok", hodnota: "1250lm (bar)" },
      { parametr: "Účinnost", hodnota: "130lm/W" },
      { parametr: "Výkon jedné diody", hodnota: "0,8W" },
      { parametr: "Jas jednoho čipu", hodnota: "104lm" },
      { parametr: "Počet diod", hodnota: "12" },
      { parametr: "Krytí", hodnota: "IP20" },
      { parametr: "Rozměr", hodnota: "920 × 15mm" },
      { parametr: "Tloušťka lišty", hodnota: "1,2mm" },
      { parametr: "Výška s čočkou", hodnota: "7mm" },
      { parametr: "LED čip", hodnota: "SANAN 10303 (2838)" },
      { parametr: "CRI (Ra)", hodnota: "80" },
      { parametr: "Úhel paprsku", hodnota: "170°" },
      { parametr: "Materiál", hodnota: "hliník + PMMA" },
      { parametr: "Životnost", hodnota: "50 000h" },
      { parametr: "Záruka", hodnota: "5 let" },
      { parametr: "Stmívání", hodnota: "Ano (s kontrolerem)" },
      { parametr: "Pracovní teplota", hodnota: "-20 až 60 °C" },
      { parametr: "Délka kabelů", hodnota: "20cm" },
      { parametr: "Žebřík", hodnota: "20 ks" },
      { parametr: "Rozteč", hodnota: "20cm" },
      { parametr: "Hloubka světelných boxů", hodnota: "4–10cm" },
      { parametr: "Balení", hodnota: "LWLB-20 / LWLB-200 / LWLB-400" }
    ],
    dokumenty: commonDocs
  },
  {
    slug: "24v-9-6w-6500k-ip65",
    kategorie: "ledbary",
    nazev: "LEDBAR 24V 9,6W 6500K IP65",
    perex: "Studeně bílá varianta se silikonovou ochranou pro venkovní světelné boxy a hluboké reklamní plochy.",
    seo: {
      title: "LEDBAR 24V 9,6W 6500K IP65 – venkovní LED bar | LightWell",
      description: "LEDBAR IP65, 24V, 9,6W, 6500K, 1250lm. Silikonová ochrana pro venkovní světelné boxy hloubky 60–240cm. Životnost 50 000h, záruka 5 let."
    },
    obrazky: [
      "https://www.lightwell.cz/media/produkty/ledbar-ip65-svazek.webp",
      "https://www.lightwell.cz/media/produkty/ledbar-ip65-detail.webp",
      "https://www.lightwell.cz/media/produkty/ledbar-detail-cocka.webp"
    ],
    specifikace: [
      { parametr: "Příkon", hodnota: "9,6W" },
      { parametr: "Napětí", hodnota: "24V DC" },
      { parametr: "Teplota barev", hodnota: "6500K" },
      { parametr: "Světelný tok", hodnota: "1250lm (bar)" },
      { parametr: "Účinnost", hodnota: "130lm/W" },
      { parametr: "Výkon jedné diody", hodnota: "0,8W" },
      { parametr: "Jas jednoho čipu", hodnota: "104lm" },
      { parametr: "Počet diod", hodnota: "12" },
      { parametr: "Krytí", hodnota: "IP65" },
      { parametr: "Rozměr", hodnota: "920 × 17mm" },
      { parametr: "Tloušťka lišty", hodnota: "1,2mm" },
      { parametr: "Výška s čočkou", hodnota: "7mm" },
      { parametr: "LED čip", hodnota: "SANAN 10303 (2838)" },
      { parametr: "CRI (Ra)", hodnota: "80" },
      { parametr: "Úhel paprsku", hodnota: "170°" },
      { parametr: "Materiál", hodnota: "hliník + PMMA" },
      { parametr: "Životnost", hodnota: "50 000h" },
      { parametr: "Záruka", hodnota: "5 let" },
      { parametr: "Stmívání", hodnota: "Ano (s kontrolerem)" },
      { parametr: "Pracovní teplota", hodnota: "-20 až 60 °C" },
      { parametr: "Délka kabelů", hodnota: "25cm" },
      { parametr: "Žebřík", hodnota: "10 ks" },
      { parametr: "Rozteč", hodnota: "25cm" },
      { parametr: "Hloubka světelných boxů", hodnota: "60–240cm" },
      { parametr: "Balení", hodnota: "LWLBO-10 / LWLBO-100 / LWLBO-300" }
    ],
    dokumenty: commonDocs
  },
  {
    slug: "24v-8w-6500k",
    kategorie: "ledbary",
    nazev: "LEDBAR 24V 8W 6500K",
    perex: "Úspornější studeně bílá varianta pro interiérové světelné boxy s nižšími nároky na svítivost.",
    seo: {
      title: "LEDBAR 24V 8W 6500K – úsporný LED bar | LightWell",
      description: "LEDBAR 24V, 8W, 6500K, 1040lm. Úsporný lineární LED bar pro interiérové světelné boxy. Životnost 50 000h, záruka 5 let."
    },
    obrazky: commonImages,
    specifikace: [
      { parametr: "Příkon", hodnota: "8W" },
      { parametr: "Napětí", hodnota: "24V DC" },
      { parametr: "Teplota barev", hodnota: "6500K" },
      { parametr: "Světelný tok", hodnota: "1040lm (bar)" },
      { parametr: "Účinnost", hodnota: "130lm/W" },
      { parametr: "Výkon jedné diody", hodnota: "0,66W" },
      { parametr: "Jas jednoho čipu", hodnota: "87lm" },
      { parametr: "Počet diod", hodnota: "12" },
      { parametr: "Krytí", hodnota: "IP20" },
      { parametr: "Rozměr", hodnota: "920 × 15mm" },
      { parametr: "Tloušťka lišty", hodnota: "1,2mm" },
      { parametr: "Výška s čočkou", hodnota: "7mm" },
      { parametr: "LED čip", hodnota: "SANAN 10303 (2838)" },
      { parametr: "CRI (Ra)", hodnota: "80" },
      { parametr: "Úhel paprsku", hodnota: "170°" },
      { parametr: "Materiál", hodnota: "hliník + PMMA" },
      { parametr: "Životnost", hodnota: "50 000h" },
      { parametr: "Záruka", hodnota: "5 let" },
      { parametr: "Stmívání", hodnota: "Ano (s kontrolerem)" },
      { parametr: "Pracovní teplota", hodnota: "-20 až 60 °C" },
      { parametr: "Délka kabelů", hodnota: "20cm" },
      { parametr: "Žebřík", hodnota: "20 ks" },
      { parametr: "Rozteč", hodnota: "20cm" },
      { parametr: "Hloubka světelných boxů", hodnota: "4–10cm" },
      { parametr: "Balení", hodnota: "LWLB-20 / LWLB-200 / LWLB-400" }
    ],
    dokumenty: commonDocs
  },
  createSource({
    slug: "hhe-100w",
    nazev: "HHE-100W-DIM",
    perex: "Kompaktní napájecí zdroj HHE s DIP stmíváním.",
    seo: {
      title: "HHE-100W-DIM - napájecí zdroj 12/24V | LightWell",
      description: "Kompaktní napájecí zdroj 100W, 12/24V DC, 155 × 36 × 23mm. DIP stmívání 40-100 %, ochrana proti přetížení a zkratu. Záruka 3 roky."
    },
    obrazky: [
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-100w.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-100w-shora.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-100w-list.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-foto-lineup.webp",
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-100w-foto-rozmery.webp"
    ],
    obrazekKarty: "https://www.lightwell.cz/media/produkty/zdroj-hhe-100w-karta.svg",
    specifikace: [
      { parametr: "Příkon", hodnota: "100W" },
      { parametr: "Rozměry", hodnota: "155 × 36 × 23mm" },
      { parametr: "Hmotnost", hodnota: "0,161 kg" },
      { parametr: "Výstupní proud", hodnota: "8,3A (12V) / 4,1A (24V)" },
      { parametr: "Účinnost", hodnota: "86,71% (12V) / 88,66% (24V)" },
      { parametr: "Stmívání", hodnota: "DIP přepínač 40 / 60 / 80 / 100 %" }
    ]
  }),
  createSource({
    slug: "hhe-200w",
    nazev: "HHE-200W-DIM",
    perex: "Kompaktní napájecí zdroj HHE s DIP stmíváním.",
    seo: {
      title: "HHE-200W-DIM - napájecí zdroj 12/24V | LightWell",
      description: "Kompaktní napájecí zdroj 200W, 12/24V DC, 227 × 36 × 23mm. DIP stmívání 40-100 %, ochrana proti přetížení a zkratu. Záruka 3 roky."
    },
    obrazky: [
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-200w.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-200w-shora.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-200w-list.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-foto-lineup.webp",
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-200w-foto-detail.webp",
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-200w-foto-rozmery.webp"
    ],
    obrazekKarty: "https://www.lightwell.cz/media/produkty/zdroj-hhe-200w-karta.svg",
    specifikace: [
      { parametr: "Příkon", hodnota: "200W" },
      { parametr: "Rozměry", hodnota: "227 × 36 × 23mm" },
      { parametr: "Hmotnost", hodnota: "0,269 kg" },
      { parametr: "Výstupní proud", hodnota: "16,6A (12V) / 8,3A (24V)" },
      { parametr: "Účinnost", hodnota: "87,74% (12V) / 89,37% (24V)" },
      { parametr: "Stmívání", hodnota: "DIP přepínač 40 / 60 / 80 / 100 %" }
    ]
  }),
  createSource({
    slug: "hhe-300w",
    nazev: "HHE-300W-DIM",
    perex: "Kompaktní napájecí zdroj HHE s DIP stmíváním.",
    seo: {
      title: "HHE-300W-DIM - napájecí zdroj 12/24V | LightWell",
      description: "Kompaktní napájecí zdroj 300W, 12/24V DC, 277 × 36 × 23mm. Účinnost až 93,57 %, DIP stmívání 40-100 %. Záruka 3 roky."
    },
    obrazky: [
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-300w.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-300w-shora.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-300w-list.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-foto-lineup.webp",
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-300w-foto-rozmery.webp"
    ],
    obrazekKarty: "https://www.lightwell.cz/media/produkty/zdroj-hhe-300w-karta.svg",
    specifikace: [
      { parametr: "Příkon", hodnota: "300W" },
      { parametr: "Rozměry", hodnota: "277 × 36 × 23mm" },
      { parametr: "Hmotnost", hodnota: "0,311 kg" },
      { parametr: "Výstupní proud", hodnota: "25A (12V) / 12,5A (24V)" },
      { parametr: "Účinnost", hodnota: "91,29% (12V) / 93,57% (24V)" },
      { parametr: "Stmívání", hodnota: "DIP přepínač 40 / 60 / 80 / 100 %" }
    ]
  }),
  createSource({
    slug: "hhe-400w",
    nazev: "HHE-400W-DIM",
    perex: "Kompaktní napájecí zdroj HHE s DIP stmíváním.",
    seo: {
      title: "HHE-400W-DIM - napájecí zdroj 12/24V | LightWell",
      description: "Kompaktní napájecí zdroj 400W, 12/24V DC, 314 × 36 × 23mm. DIP stmívání 40-100 %, ochrana proti přetížení a zkratu. Záruka 3 roky."
    },
    obrazky: [
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-400w.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-400w-shora.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-400w-list.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-foto-lineup.webp",
      "https://www.lightwell.cz/media/produkty/zdroj-hhe-400w-foto-rozmery.webp"
    ],
    obrazekKarty: "https://www.lightwell.cz/media/produkty/zdroj-hhe-400w-karta.svg",
    specifikace: [
      { parametr: "Příkon", hodnota: "400W" },
      { parametr: "Rozměry", hodnota: "314 × 36 × 23mm" },
      { parametr: "Hmotnost", hodnota: "0,355 kg" },
      { parametr: "Výstupní proud", hodnota: "33,3A (12V) / 16,6A (24V)" },
      { parametr: "Stmívání", hodnota: "DIP přepínač 40 / 60 / 80 / 100 %" }
    ]
  }),
  createSource({
    slug: "hhx-50w",
    nazev: "HHX-50W",
    perex: "Ultra tenký napájecí zdroj HHX bez stmívání.",
    seo: {
      title: "HHX-50W - ultra tenký napájecí zdroj 12/24V | LightWell",
      description: "Ultra tenký napájecí zdroj 50W, 12/24V DC, profil pouhých 20,5 × 20,5mm. Pro úzké profily a lištové systémy. Záruka 3 roky."
    },
    obrazky: [
      "https://www.lightwell.cz/media/produkty/zdroj-hhx-50w.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhx-50w-shora.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhx-50w-list.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhx-foto-lineup.webp",
      "https://www.lightwell.cz/media/produkty/zdroj-hhx-foto-svorka.webp"
    ],
    obrazekKarty: "https://www.lightwell.cz/media/produkty/zdroj-hhx-50w-karta.svg",
    specifikace: [
      { parametr: "Příkon", hodnota: "50W" },
      { parametr: "Rozměry", hodnota: "153 × 20,5 × 20,5mm" },
      { parametr: "Hmotnost", hodnota: "0,09 kg" },
      { parametr: "Výstupní proud", hodnota: "4,16A (12V) / 2,08A (24V)" },
      { parametr: "Účinnost", hodnota: "> 86% (12V) / > 87% (24V)" }
    ]
  }),
  createSource({
    slug: "hhx-100w",
    nazev: "HHX-100W-DIM",
    perex: "Ultra tenký napájecí zdroj HHX s DIP stmíváním.",
    seo: {
      title: "HHX-100W-DIM - ultra tenký napájecí zdroj 12/24V | LightWell",
      description: "Ultra tenký napájecí zdroj 100W, 12/24V DC, profil 20,5 × 20,5mm. DIP stmívání 100/50 %. Záruka 3 roky."
    },
    obrazky: [
      "https://www.lightwell.cz/media/produkty/zdroj-hhx-100w.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhx-100w-shora.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhx-100w-list.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhx-foto-lineup.webp",
      "https://www.lightwell.cz/media/produkty/zdroj-hhx-foto-dip.webp",
      "https://www.lightwell.cz/media/produkty/zdroj-hhx-foto-svorka.webp"
    ],
    obrazekKarty: "https://www.lightwell.cz/media/produkty/zdroj-hhx-100w-karta.svg",
    specifikace: [
      { parametr: "Příkon", hodnota: "100W" },
      { parametr: "Rozměry", hodnota: "215 × 20,5 × 20,5mm" },
      { parametr: "Hmotnost", hodnota: "0,12 kg" },
      { parametr: "Výstupní proud", hodnota: "8,33A (12V) / 4,16A (24V)" },
      { parametr: "Účinnost", hodnota: "> 86% (12V) / > 87,5% (24V)" },
      { parametr: "Stmívání", hodnota: "DIP přepínač 100 / 50 %" }
    ]
  }),
  createSource({
    slug: "hhx-150w",
    nazev: "HHX-150W-DIM",
    perex: "Ultra tenký napájecí zdroj HHX s DIP stmíváním.",
    seo: {
      title: "HHX-150W-DIM - ultra tenký napájecí zdroj 12/24V | LightWell",
      description: "Ultra tenký napájecí zdroj 150W, 12/24V DC, profil 20,5 × 20,5mm. DIP stmívání 100/50 %. Záruka 3 roky."
    },
    obrazky: [
      "https://www.lightwell.cz/media/produkty/zdroj-hhx-150w.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhx-150w-shora.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhx-150w-list.svg",
      "https://www.lightwell.cz/media/produkty/zdroj-hhx-foto-lineup.webp",
      "https://www.lightwell.cz/media/produkty/zdroj-hhx-foto-dip.webp",
      "https://www.lightwell.cz/media/produkty/zdroj-hhx-foto-svorka.webp"
    ],
    obrazekKarty: "https://www.lightwell.cz/media/produkty/zdroj-hhx-150w-karta.svg",
    specifikace: [
      { parametr: "Příkon", hodnota: "150W" },
      { parametr: "Rozměry", hodnota: "248 × 20,5 × 20,5mm" },
      { parametr: "Hmotnost", hodnota: "0,16 kg" },
      { parametr: "Výstupní proud", hodnota: "12,5A (12V) / 6,25A (24V)" },
      { parametr: "Účinnost", hodnota: "> 86% (12V) / > 87% (24V)" },
      { parametr: "Stmívání", hodnota: "DIP přepínač 100 / 50 %" }
    ]
  })
];